export default "__VITE_ASSET__fd1ef47a__"